export const getAbsoluteUrl = (url) => {
    const a = document.createElement('a');
    a.href = url;
    return a.href;
};
